// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4660":"css/app.7048","6307":"css/admin-app.7048"}[chunkId] + ".css";
};